import { render, staticRenderFns } from "./TaskTemplateCard.vue?vue&type=template&id=bcde8a32&scoped=true&"
import script from "./TaskTemplateCard.vue?vue&type=script&lang=ts&"
export * from "./TaskTemplateCard.vue?vue&type=script&lang=ts&"
import style0 from "../theme/plugins/themify-icons/themify-icons.css?vue&type=style&index=0&id=bcde8a32&prod&scoped=true&lang=css&"
import style1 from "./TaskTemplateCard.vue?vue&type=style&index=1&id=bcde8a32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcde8a32",
  null
  
)

export default component.exports